class GallerySection extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.panels = [];
    this.onTabClick = this.onTabClick.bind(this);
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-gallery-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-gallery-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick);
    });
  }

  disconnectedCallback() {
    this.tabs.forEach((tab) => {
      tab.removeEventListener('click', this.onTabClick);
    });
  }

  onTabClick(event) {
    const tab = event.currentTarget;
    const folderId = tab.getAttribute('data-folder-id');
    if (!folderId) return;

    this.activateFolder(folderId);
  }

  activateFolder(folderId) {
    this.tabs.forEach((tab) => {
      const isActive = tab.getAttribute('data-folder-id') === folderId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.getAttribute('data-folder-id') === folderId;
      panel.classList.toggle('is-active', isActive);
    });
  }
}

if (!customElements.get('gallery-section')) {
  customElements.define('gallery-section', GallerySection);
}

